import { useCampaignInfoVisible } from '../../store/campaignsStore';
import type { CampaignTypes } from '../../types/campaign.types';

/**
 * Single source of truth for "should this campaign card run its live sub-fetches
 * (prizes / leaderboard)".
 *
 * Visibility is observed on the always-rendered card root (see CampaignCard),
 * which intersects the viewport correctly in every context — lobby, carousel,
 * single view and the ingame compact view — so this simply reflects whether the
 * card is on screen. (The `isHeaderCollapsed && selected` clause inside
 * `useCampaignInfoVisible` keeps the selected card "active" while the header is
 * collapsed, where its data is shown in the sticky panel.)
 */
export const useCampaignCardActive = (
  campaignId?: string,
  campaignType?: CampaignTypes,
): boolean => useCampaignInfoVisible(campaignId, campaignType);
